import { BuyGuideVendorGeneralConditionList } from '../../../components/BuyGuide';

export function BuyGuideVendorGeneralConditions() {
  return <BuyGuideVendorGeneralConditionList />;
}
